const DEFAULT_PLATFORM_AVATAR_URL = "/uniflo-reference/logo.png";
const UNIFLO_SYSTEM_USERNAME = "uniflo-ai";
const UNIFLO_SYSTEM_EMAIL = "ai@uniflo.app";
const UNIFLO_SYSTEM_IDENTITY = "uniflo_ai";
// Display-name fallback: some payloads (e.g. the clan roles serializer) drop
// the username/email/system markers and only carry a derived name. The system
// user's first+last name resolves to exactly "Uniflo AI", so treat that as a
// last-resort identity signal. Keep this list tight to avoid false positives.
const UNIFLO_SYSTEM_DISPLAY_NAMES = new Set(["uniflo ai"]);

function normalizeIdentityValue(value) {
  return `${value ?? ""}`.trim().toLowerCase();
}

export function isUnifloSystemIdentity(userLike) {
  if (!userLike || typeof userLike !== "object") return false;

  const username = normalizeIdentityValue(userLike.username);
  const email = normalizeIdentityValue(userLike.email || userLike.email_original);
  const systemIdentity = normalizeIdentityValue(
    userLike?.custom_fields?.systemIdentity || userLike?.systemIdentity
  );
  const displayName = normalizeIdentityValue(
    userLike.displayName ||
      userLike?.custom_fields?.displayName ||
      userLike.name
  );

  return (
    userLike.isSystemAi === true ||
    username === UNIFLO_SYSTEM_USERNAME ||
    email === UNIFLO_SYSTEM_EMAIL ||
    systemIdentity === UNIFLO_SYSTEM_IDENTITY ||
    UNIFLO_SYSTEM_DISPLAY_NAMES.has(displayName)
  );
}

export function getPlatformAvatarUrl(publicConfig) {
  if (typeof publicConfig === "string") {
    return `${publicConfig || DEFAULT_PLATFORM_AVATAR_URL}`.trim() || DEFAULT_PLATFORM_AVATAR_URL;
  }

  const platformBranding = publicConfig?.platformBranding || {};
  const configuredLogo =
    platformBranding.logoUrl ||
    platformBranding.touchIconUrl ||
    platformBranding.faviconUrl;

  return `${configuredLogo || DEFAULT_PLATFORM_AVATAR_URL}`.trim() || DEFAULT_PLATFORM_AVATAR_URL;
}

export function getUnifloSystemAvatarUrl(userLike, publicConfig) {
  return isUnifloSystemIdentity(userLike) ? getPlatformAvatarUrl(publicConfig) : "";
}

export { DEFAULT_PLATFORM_AVATAR_URL };
